import "./resource";
import { MediaUpsert } from "../../typings/thor";

class MediaService {
    public static $inject: string[] = [
        "mediaResource"
    ];

    private mediaResource;

    constructor(
        mediaResource
    ) {
        this.mediaResource = mediaResource;
    }

    public deleteMedia(id: number) {
        return this.mediaResource().deleteMedia({ id: id }).$promise;
    }

    public updateMedia(id: number, fields: MediaUpsert) {
        return this.mediaResource().updateMedia({ id: id }, fields).$promise;
    }
}

angular
    .module("thor.core.media.service", [
        "thor.core.media.resource"
    ])
    .service("mediaService", MediaService);
